export default {"src":"/_next/static/media/hipl.6c71d9ca.svg","height":100,"width":152,"blurWidth":0,"blurHeight":0};